export default __webpack_public_path__ + "static/media/advantage3.dcd18a36.png";